<template>
  <nav class="bottom-nav">
    <router-link to="/bookings" class="nav-item" active-class="active">
      <i class="bi bi-calendar-check"></i>
      <span>Bookings</span>
    </router-link>

    <router-link to="/reviews" class="nav-item" active-class="active">
      <i class="bi bi-qr-code-scan"></i>
      <span>Reviews</span>
    </router-link>

    <router-link to="/quote" class="nav-item" active-class="active">
      <i class="bi bi-file-text"></i>
      <span>Quote</span>
    </router-link>

    <router-link to="/profile" class="nav-item" active-class="active">
      <i class="bi bi-person"></i>
      <span>Profile</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'BottomNavigation',
  props: {
    isTermiteSpec: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--navbar-height);
  background-color: var(--surface);
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  text-decoration: none;
  color: var(--text-secondary);
  transition: all 0.2s ease;
  position: relative;
  padding: 0.5rem 0;
}

.nav-item i {
  font-size: 1.25rem;
  margin-bottom: 0.25rem;
}

.nav-item span {
  font-size: 0.75rem;
  font-weight: 500;
}

.nav-item.active {
  color: var(--primary);
}

.nav-item.active i {
  transform: scale(1.1);
}

</style>